import React from 'react'

import { section } from '@ui-kit/components/layoutComponents/Section/styles'

import type { WebProps } from './types'

const Section = (props: WebProps) => (
  <div {...props} className={section({ className: props.className })} />
)

export default Section
